import { useEffect } from 'react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { useRollStore } from '../store/roll-store'
import { supabase } from '@/lib/supabase/client'

export function RollStatusObserver() {
  const { user } = useAuth()
  const { checkRollStatus } = useRollStore()

  useEffect(() => {
    if (!user) return

    // Verificar status inicial
    checkRollStatus(user.id)

    // Escutar mudanças na tabela profiles
    const channel = supabase
      .channel('roll-status')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'profiles',
          filter: `id=eq.${user.id}`
        },
        () => {
          checkRollStatus(user.id)
        }
      )
      .subscribe()

    return () => {
      channel.unsubscribe()
    }
  }, [user, checkRollStatus])

  return null
} 